import { useLocaleStoreWithOut } from '@/store/modules/locale';
import { createI18n } from 'vue-i18n';
import type { I18n, I18nOptions } from 'vue-i18n';
import { setHtmlPageLang, setLoadLocalePool } from './helper';

import { App } from 'vue';

export let i18n: ReturnType<typeof createI18n>;

async function createI18nOptions(): Promise<I18nOptions> {
    const localeStore = useLocaleStoreWithOut();
    const locale = localeStore.getLocale;
    const defaultLocal = await import(`./lang/${locale}.ts`);
    const message = defaultLocal.default?.message ?? {};
    const { fallback, availableLocales } = localeStore.localInfo;

    setHtmlPageLang(locale);
    setLoadLocalePool(loadLocalePool => loadLocalePool.push(locale));

    return {
        legacy: false,
        locale,
        fallbackLocale: fallback,
        messages: {
            [locale]: message,
        },
        availableLocales,
        sync: true,
        silentTranslationWarn: import.meta.env.MODE !== 'development',
        missingWarn: false,
        silentFallbackWarn: import.meta.env.MODE !== 'development',
    }
}

export async function setupI18n(app: App) {
    const options = await createI18nOptions();
    i18n = createI18n(options) as I18n;
    app.use(i18n);
}
